import React, {
  useCallback,
  useEffect,
  useReducer,
  useRef,
  useState,
} from 'react';
import Toggle from './Toggle.jsx';
import DisplayEmoji from 'modules/emoji/_components/DisplayEmoji/index.js';
import style from './emoji.module.css';
import PanelWrapper from './Panel/PanelWrapper.jsx';
import Panel from './Panel/Panel.jsx';
import ExclusiveContent from '../../../../components/ExclusiveContent/index.js';
import { Feature } from '#/modules/feature-flag/feature.jsx';
import { Rating } from '#/modules/emoji/_components/raiting/rating.jsx';

export { Emoji };

function Emoji(props) {
  const {
    /* own, from root */
    options,
    /* very own, from extension */
    isShowPanel,
    isEmojiHidden,
    toggleShowPanel,
    closePanel,

    /* fake state, derived from own */
    emojiArray,
    consumable = false,
    /* state */
    devicePlatform = 'web',
    performanceRate,
    assets,

    sendEmoji,

    emoji$,
    history,
  } = props;

  const [panelOrientation, setPanelOrientation] = useState('vertical');

  const [, forceUpdate] = useReducer((x) => x + 1, 0);

  useEffect(() => {
    const uglyPatch = () => {
      setTimeout(() => {
        forceUpdate();
      });
    };
    uglyPatch();
    window.addEventListener('resize', uglyPatch);

    return () => {
      window.removeEventListener('resize', uglyPatch);
    };
  }, []);

  /***
   *
   * @type {React.MutableRefObject<HTMLDivElement>}
   */
  const containerRef = useRef();

  const getAssetByUrl = useCallback(
    (url) => {
      return assets.find((asset) => asset.url === url);
    },
    [assets],
  );

  if (emojiArray.length === 0) {
    // console.log('empty pack')
    return null;
  }

  if (!consumable) {
    // console.log('not consumable');
    return null;
  }

  const emojiContainerHeight = containerRef.current?.offsetHeight ?? 0;

  return (
    <>
      <section className={style.container} ref={containerRef}>
        <Toggle onToggle={toggleShowPanel} toggleAction={toggleShowPanel} />

        <DisplayEmoji
          getAssetByUrl={getAssetByUrl}
          isHidden={isEmojiHidden}
          silentMode={!isShowPanel}
          emojiArray={emojiArray}
          performanceRate={performanceRate}
        />
      </section>
      <ExclusiveContent key={'emoji'} collapseMode={'visibility'}>
        <PanelWrapper
          isShow={isShowPanel}
          emojiArray={emojiArray}
          devicePlatform={devicePlatform}
          panelOrientation={panelOrientation}
          closePanel={closePanel}
        >
          <Panel
            emojiArray={emojiArray}
            getAssetByUrl={getAssetByUrl}
            emojiContainerHeight={emojiContainerHeight}
            panelOrientation={panelOrientation}
            setPanelOrientation={setPanelOrientation}
            onSendEmoji={sendEmoji}
          >
            <Feature name={'emoji-rating'}>
              <Rating
                emojiArray={emojiArray}
                emoji$={emoji$}
                interval={options.rating_interval}
                history={history}
              />
            </Feature>
          </Panel>
        </PanelWrapper>
      </ExclusiveContent>
    </>
  );
}
